var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasEditAccess)?_c('v-icon',{staticClass:"mr-1",attrs:{"small":""},on:{"click":function($event){_vm.$parent.$parent.$parent.editItem(_vm.editingItem)}}},[_vm._v("edit")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }